module.exports = __webpack_public_path__ + "img/approval.0688d924.svg";